import PropTypes from 'prop-types'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { useRelations } from '@hooks/useAgencyProviderDeadlineGroup'

const AgencyProviderDeadlineGroupListItem = (props) => {
  const { agencyProviderDeadlineGroup } = props

  const { provider, providerDeadlineGroup } = useRelations(agencyProviderDeadlineGroup)

  const {
    deadlines,
    id,
    title,
  } = providerDeadlineGroup

  const deadlineCount = Object.values(deadlines).reduce((acc, deadline) => {
    if (deadline.time) acc += 1
    return acc
  }, 0)

  return (
    <DashboardModuleListItem
      secondaryText={deadlineCount === 1 ? '1 Deadline' : `${deadlineCount} Deadlines`}
      title={`# ${id} ${provider.title}`}
    >
      <DashboardModuleListItem.TertiaryText>
        {title}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

AgencyProviderDeadlineGroupListItem.propTypes = {
  agencyProviderDeadlineGroup: PropTypes.object.isRequired,
}

export default AgencyProviderDeadlineGroupListItem
